import { render, staticRenderFns } from "./midway.vue?vue&type=template&id=53a16e01&scoped=true&"
import script from "./midway.vue?vue&type=script&lang=js&"
export * from "./midway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a16e01",
  null
  
)

export default component.exports